import React from 'react'
import { routes } from '../../router/routes'
import { useLocationScroll } from '../../hooks'
import {
  CookiesPolicyLink as SharedCookiesPolicyLink,
  ContactLink as SharedContactLink,
  TandCLink as SharedTandCLink,
  PrivacyPolicyLink as SharedPrivacyPolicyLink,
  A11yStatementLink as SharedA11yStatementLink
} from '../policy-links'

const PrivacyPolicyLink = () => (
  <SharedPrivacyPolicyLink data-test='footer-privacy-policy-link' />
)

const TandCLink = () => (
  <SharedTandCLink
    to={routes.tandc.path}
    state={{ [useLocationScroll.SCROLLTOP]: true }}
    data-test='footer-tandc-link'
  >
    Terms and Conditions
  </SharedTandCLink>
)

const ContactLink = () => (
  <SharedContactLink data-test='footer-contact-link'>
    Contact Us
  </SharedContactLink>
)

const CookiesPolicyLink = () => (
  <SharedCookiesPolicyLink data-test='footer-cookies-policy-link' />
)

const A11yStatementLink = () => (
  <SharedA11yStatementLink data-test='footer-a11y-statement-link' />
)

export {
  ContactLink,
  CookiesPolicyLink,
  PrivacyPolicyLink,
  TandCLink,
  A11yStatementLink
}
